var styles = {"fontElementMap":"Ru29B","orderedlist":"tDHax","bulletedlist":"TXKh3","listItem":"M1o4B"};

export { styles as s };
//# sourceMappingURL=lists-f132e1ba.js.map
